import { HookDefinition } from "@modules/sdk/hooks/HookDefinition";

export interface WishlistAddItemHookInput {
    readonly productId: number;
    readonly variantId: number;
    readonly wishlistId: number;
}

export interface WishlistAddItemHookResult {
    readonly productId: number;
    readonly variantId: number;
    readonly wishlistId: number;
}

const WISHLIST_ADD_ITEM = "wishlist.addItem";

const WishlistAddItemHookDefinition: HookDefinition<
    WishlistAddItemHookInput,
    WishlistAddItemHookResult
> = {
    name: WISHLIST_ADD_ITEM,
    defaultHandler: (
        input: WishlistAddItemHookInput
    ): Promise<WishlistAddItemHookResult> => {
        return Promise.resolve({
            productId: input.productId,
            variantId: input.variantId,
            wishlistId: input.wishlistId,
        });
    },
};

export const WishlistHooksDefinitions = {
    ADD_ITEM: WishlistAddItemHookDefinition,
} as const;
